<script>
  import { onMount } from 'svelte';
  import { link } from 'svelte-spa-router';
  import { locale, _, isLoading } from 'svelte-i18n';
  import { settingsStore, refreshSettings } from '../stores/settings';
  import { switchTeam, updateLanguage, trackEvent } from '../lib/apiService';

  export let darkMode = true;
  export let toggleTheme = () => {};
  export let user = {id: ''};

  // Get initial language from localStorage or default to 'en'
  const savedLanguage = localStorage.getItem('preferred-language') || 'en';
  locale.set(savedLanguage);

  async function toggleLanguage() {
    const newLocale = $locale === 'nl' ? 'en' : 'nl';
    locale.set(newLocale);
    
    try {
      await updateLanguage(newLocale, (result, status) => {
        if (status === 200) {
          // Language updated successfully, refresh settings to sync the store
          refreshSettings();
          trackEvent('switch_language', {
            module: "navigation",
            action_type: "change_settings",
            description: 'Switch language',
            value: newLocale
          }, user.id);
        } else {
          console.error('Failed to update language preference:', result);
        }
      });
    } catch (error) {
      console.error('Error updating language:', error);
    }
  }

  let teamDropdown;

  async function handleTeamSwitch(teamId) {
    try {
      await switchTeam(teamId, (result, status) => {
        if (status === 200) {
          console.log('Team switched successfully:', result);
          trackEvent('switch_team', {
            module: "navigation",
            action_type: "change_settings",
            description: 'Switch team',
            value: teamId
          }, user.id);
          // Refresh settings to update the active team
          window.location.reload();
        } else {
          console.error('Failed to switch team:', result);
        }
      });
    } catch (error) {
      console.error('Error switching team:', error);
    }
  }

  onMount(() => {
    // console.log('🔄 Nav mounted');
    // console.log('🔄 settingsStore:', $settingsStore);
  });
  
  
  // You can add any navigation-related logic here
</script>


{#if $isLoading}
  <nav>Loading...</nav>
{:else}
<nav>
    <ul>
      <li><strong><a href="/" use:link class="brand-text contrast">P</a></strong></li>
      {#if $settingsStore.teams?.length > 0}
        <li>
          <details class="dropdown" bind:this={teamDropdown}>
            <summary>
              {#if $settingsStore.active_team?.club?.logo}
                <img 
                  src={$settingsStore.active_team.club.logo} 
                  alt={$settingsStore.active_team.club.name}
                  class="club-logo"
                />
              {/if}
              {$settingsStore.active_team?.name || $_('nav.select_team')}
            </summary>
            <ul>
              {#each $settingsStore.teams as team}
                <li>
                  <a 
                    href="#" 
                    on:click|preventDefault={() => handleTeamSwitch(team.id)}
                    class:active={$settingsStore.active_team?.id === team.id}
                  >
                    {#if team.club?.logo}
                      <img 
                        src={team.club.logo} 
                        alt={team.club.name}
                        class="club-logo"
                      />
                    {/if}
                    {team.name.slice(0, 8)}
                  </a>
                </li>
                {/each}
                <li><hr></li>
              <li>
                <a href="/account/#/settings?tab=teams&view=add" class="contrast">
                  <ion-icon name="add-outline"></ion-icon>
                  {$_('nav.add_team')}
                </a>
              </li>
            </ul>
          </details>
        </li>
      {/if}
    </ul>
    <ul>
       <li>
        <a href="https://pankla.com/hulp" target="_blank" class="contrast theme-toggle pr-2 pl-0">
          <ion-icon name="help-circle-outline" class="pt-2 large"></ion-icon>
        </a>
      </li>
      <li>
        <a href="#" on:click|preventDefault={toggleTheme} class="contrast theme-toggle pr-4 pl-0">
          {#if darkMode}
            <ion-icon name="sunny" class="pt-2"></ion-icon>
          {:else}
            <ion-icon name="moon" class="pt-2"></ion-icon>
          {/if}
        </a>
      </li>
      <li>
        <a href="#" on:click|preventDefault={toggleLanguage} class="outline contrast">
          {$locale === 'en' ? 'NL' : 'EN'}
        </a>
      </li>
      {#if user.id}
      <li>
        <details class="dropdown">
          <summary>
            <ion-icon name="menu-outline" class="pt-1"></ion-icon>
          </summary>
          <ul dir="rtl">
            <li><a href="/account/#/settings?tab=teams">{$_('nav.teams')}</a></li>
            <li><a href="/account/#/settings?tab=notifications">{$_('nav.notifications')}</a></li>
            <li><a href="/account/#/settings?tab=settings">{$_('nav.settings')}</a></li>
            <li><a href="/account/#/logout">{$_('nav.logout')}</a></li>
          </ul>
        </details>
      </li>
      {/if}
    </ul>
  </nav>
{/if}

<style>
  
  .theme-toggle {
    border: none;
    background-color: transparent;
    color: var(--app-text-muted);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    border-radius: 50%;
    margin-left: 0.5rem;
    margin-bottom: 0;
    transition: all 0.2s;
  }
  
  .theme-toggle:hover {
    color: var(--app-text);
    background-color: rgba(0, 0, 0, 0.05);
  }
  
  @font-face {
    font-family: 'Gagalin';
    src: url('/fonts/gagalin/Gagalin-Regular.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  .brand-text {
    font-family: 'Gagalin', sans-serif;
    text-decoration: none;
    color: var(--app-text);
    font-size: 1.5rem;
  }
  
  .brand-text:hover {
    color: inherit;
    opacity: 0.9;
  }

  .club-logo {
    width: 25px;
    height: 25px;
  }
  
  ion-icon.large {
    font-size: 1.5rem;
  }

  details.dropdown summary {
    background-color: transparent;
  }

  details.dropdown summary:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

</style> 